import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { AccordionMinus2, AccordionPlus2 } from "../../images";
import AccordionList from "./accordion";
import AccordianCard from "./resource-cards";

const Resources = ({ course, type = null, isEnrolled: isEnrolledProp }) => {
  const { user } = useSelector((state) => state);
  const isEnrolled = useMemo(() => {
    if (typeof isEnrolledProp === "boolean") return isEnrolledProp;
    if (!course?.id) return false;
    const courses = user?.enrolledCourses || user?.enrolled_courses || [];
    return courses.some((c) => {
      const cid = typeof c === "object" ? c.id || c.course_id : c;
      return Number(cid) === Number(course.id);
    });
  }, [isEnrolledProp, user, course?.id]);

  const SECTIONS = course?.resources || [];

  if (SECTIONS.length === 0) {
    return (
      <div className="mt-[40px] p-8 bg-white rounded-[4px] text-center text-[#828282] border border-gray-100">
        No resources available for this course yet.
      </div>
    );
  }

  return (
    <AccordionList
      sections={SECTIONS}
      icons={{ plus: AccordionPlus2, minus: AccordionMinus2 }}
      renderItem={(item, index) => (
        <AccordianCard
          key={index}
          item={item}
          tab="resources"
          type={type}
          isEnrolled={isEnrolled}
          course={course}
        />
      )}
      emptyMessage="No resources available"
    />
  );
};

export default Resources;
